module.exports = __webpack_public_path__ + "h5/img/banner_act.aac15da6.png";